module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FBMHD"
  }, [_vm._v("Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "SECTION-INTRO1"
  }, [_vm._v("Now that you have all your basic equipment to hand, you are ready to begin your preparations for baking. You can use almost any recipe for the decorated cupcake projects in this book, and I have listed some of my special favourites here for you to choose from.")]), _vm._v(" "), _c('p', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/120314_BMIY_232_fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b741ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02.vue
// module id = 69
// module chunks = 0